import { render, staticRenderFns } from "./AppAccSafari.vue?vue&type=template&id=2705e35a&scoped=true&"
import script from "./AppAccSafari.vue?vue&type=script&lang=js&"
export * from "./AppAccSafari.vue?vue&type=script&lang=js&"
import style0 from "./AppAccSafari.vue?vue&type=style&index=0&id=2705e35a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705e35a",
  null
  
)

export default component.exports